import { useState } from "react";
import { faqList } from "@/mocks/sections";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.2em] text-accent-600">
            <i className="ri-question-line text-sm leading-none"></i>
            常见问题 FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于吃瓜百科，你可能想问
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-foreground-600">
            对网站定位、内容来源与转载方式有任何疑问，都可以先在这里找找答案。
          </p>
        </div>

        <div className="mt-9 divide-y divide-background-200 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200">
          {faqList.map((item, i) => {
            const active = open === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(active ? -1 : i)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer md:px-6"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-xs font-bold ${
                        active
                          ? "bg-primary-600 text-background-50"
                          : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-[15px] font-medium text-foreground-900">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl leading-none text-foreground-500 transition-transform ${
                      active ? "rotate-180 text-primary-600" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[72px] text-sm leading-7 text-foreground-600 md:px-6 md:pl-[76px]">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}